import { moneyFormatSigns } from '../../../utils/contant';
import type { CatalogItem, ReadymadeOutfit, CustomOutfit } from '../types';

interface ItemCardProps {
  item: CatalogItem;
  onAdd: (item: CatalogItem) => void;
}

const isReadymade = (item: CatalogItem): item is ReadymadeOutfit => {
  return 'display_name' in item;
};

const formatPrice = (min: number, max: number): string => {
  const { rupee } = moneyFormatSigns;

  if (min === 0 && max === 0) {
    return `${rupee} 0`;
  }

  if (min === max || min === 0) {
    return `${rupee} ${max.toLocaleString('en-IN')}`;
  }

  return `${rupee} ${min.toLocaleString('en-IN')} - ${rupee} ${max.toLocaleString('en-IN')}`;
};

const getItemName = (item: CatalogItem): string => {
  if (isReadymade(item)) {
    return item.display_name || item.name;
  }

  return (item as CustomOutfit).outfit_name;
};

const getItemImage = (item: CatalogItem): string | null => {
  if (isReadymade(item)) {
    return item.cover_image_url;
  }

  return (item as CustomOutfit).icon_url;
};

const ItemCard = ({ item, onAdd }: ItemCardProps) => {
  const name = getItemName(item);
  const imageUrl = getItemImage(item);
  const price = formatPrice(item.min_value, item.max_value);

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 flex flex-col items-center hover:shadow-md transition-shadow">
      <div className="w-20 h-20 mb-3 flex items-center justify-center">
        {imageUrl ? (
          <img src={imageUrl} alt={name} className="max-w-full max-h-full object-contain rounded" />
        ) : (
          <div className="w-16 h-16 bg-gray-100 rounded flex items-center justify-center">
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#9CA3AF"
              strokeWidth="1.5"
            >
              <path d="M20.38 3.46L16 2l-4 1L8 2 3.62 3.46A2 2 0 002 5.4V21a1 1 0 001.5.87L8 19l4 2 4-2 4.5 2.87A1 1 0 0022 21V5.4a2 2 0 00-1.62-1.94z" />
            </svg>
          </div>
        )}
      </div>
      <p className="text-sm font-medium text-gray-800 text-center truncate w-full">{name}</p>
      <p className="text-xs text-gray-500 mt-1">{price}</p>
      <button
        onClick={() => onAdd(item)}
        className="mt-3 w-full py-1.5 bg-blue-500 text-white text-sm font-medium rounded-lg hover:bg-blue-600 transition-colors"
      >
        Add+
      </button>
    </div>
  );
};

export default ItemCard;
